import React from "react";
import Login from "../pages/Login/Login";
import Welcome from "../pages/Users/Welcome/Welcome";
import Register from "../pages/Register/Register";
import PageNotFound from "../pages/PageNotFound/PageNotFound";
import Layout from "../pages/Layout/Layout";
import Home from "../pages/Home/Home";
import WishList from "../pages/Users/WishList";
import ViewedProfile from "../pages/Users/ViewedProfile";
import DailyRecomProfilePage from "../pages/Home/ProfilePage";
import HoroscopeProfilePage from "../pages/Home/ProfilePage/HoroscopeProfilePage";
import NewProfilesPage from "../pages/Home/ProfilePage/NewProfilesPage";
import PreferenceProfiePage from "../pages/Home/ProfilePage/PreferenceProfiePage";
import Profile from "../pages/Users/Profile/Profile";
import ProfileAssist from "../pages/Home/ProfilePage/ProfileAssist";
import CompareProfile from "../pages/Home/ProfilePage/CompareProfile";
import ForgotPassword from "../pages/ForgotPassword/ForgotPassword";
import ResetPassword from "../pages/ResetPassword/ResetPassword";
import ViewProfile from "../pages/Users/ViewProfile/ViewProfile";
import EditProfile from "../pages/Users/EditProfile/EditProfile";
import { CustomerId } from "../pages/Users/EditCustomer/CustomerId";
import EditPreferences from "../pages/Users/EditPreferences/EditPreferences";
import Chat from "../pages/Chat";
import Subscription from "../pages/Subscription";
import PaymentHistory from "../pages/Users/PaymentHistory";
import AdminLogin from "../pages/Admin/AdminLogin/AdminLogin";
import SubOrdinates from "../pages/SubOrdinates/SubOrdinates";
import Associates from "../pages/Associates/Associates";
import AdminDashboard from "../pages/Admin/AdminDashboard/AdminDashboard";
import TermsAndConditions from "../pages/Agreement/TermsAndConditions";
import PrivacyPolicy from "../pages/Agreement/PrivacyPolicy";
import { Navigate, Outlet } from "react-router-dom";
import AssosiateProfile from "../pages/Associates/ViewProfile/AssosiateProfile";
import { EditAssosiateProfile } from "../pages/Associates/EditProfile/EditAssosiateProfile";
import AssociateEarningsInfo from "../pages/Associates/Earnings/EarningsInfo";
import SubOrdinatesViewProfile from "../pages/SubOrdinates/ViewProfile";
import { EditSubordinateProfile } from "../pages/SubOrdinates/EditProfile";
import SubordinateEarningsInfo from "../pages/SubOrdinates/Earnings/EarningsInfo";
import CustomerDetails from "../pages/SubOrdinates/CustomerDetails";
import { CreateAssosiate } from "../pages/Admin/CreateAssosiate/CreateAssosiate";
import { CreateSubordinate } from "../pages/Admin/CreateSubordinate/CreateSubordinate";
import EmployeeDashboard from "../pages/EmployeeDashboard";
import SearchByPartner from "../pages/Users/SearchByPartner";
import FilteredCustomers from "../pages/Users/SearchByPartner/FilteredCustomers";
import SubscriptionNew from "../pages/SubscriptionNew";
import ChildSafetyStandards from "../pages/Agreement/ChildSafetyStandards";
import AboutUs from "../pages/Agreement/AboutUs";
import Services from "../pages/Agreement/Services";
import RefundPolicies from "../pages/Agreement/RefundPolicies";
import PaymentStatus from "../pages/PaymentStatus";

const routes = (isLoggedIn) => [
  {
    path: "/",
    element: !isLoggedIn ? <Welcome /> : <Navigate to="/auth/home" />,
  },
  {
    path: "login",
    element: !isLoggedIn ? <Login /> : <Navigate to="/auth/home" />,
  },
  {
    path: "admin/login",
    element: !isLoggedIn ? <AdminLogin /> : <Navigate to="/auth/home" />,
  },
  {
    path: "associates/login",
    element: !isLoggedIn ? <Login /> : <Navigate to="/auth/home" />,
  },
  {
    path: "register",
    element: !isLoggedIn ? <Register /> : <Navigate to="/auth/home" />,
  },
  {
    path: "forgot-password",
    element: !isLoggedIn ? <ForgotPassword /> : <Navigate to="/auth/home" />,
  },
  {
    path: "associates/forgot-password",
    element: !isLoggedIn ? <ForgotPassword /> : <Navigate to="/auth/home" />,
  },
  {
    path: "reset-password/:id",
    element: !isLoggedIn ? <ResetPassword /> : <Navigate to="/auth/home" />,
  },
  {
    path: "associates/reset-password/:id",
    element: !isLoggedIn ? <ResetPassword /> : <Navigate to="/auth/home" />,
  },
  {
    path: "employee/login",
    element: !isLoggedIn ? <Login /> : <Navigate to="/auth/home" />,
  },
  {
    path: "employee/forgot-password",
    element: !isLoggedIn ? <ForgotPassword /> : <Navigate to="/auth/home" />,
  },
  {
    path: "employee/reset-password/:id",
    element: !isLoggedIn ? <ResetPassword /> : <Navigate to="/auth/home" />,
  },
  {
    path: "admin/forgot-password",
    element: !isLoggedIn ? <ForgotPassword /> : <Navigate to="/auth/home" />,
  },
  {
    path: "admin/reset-password/:id",
    element: !isLoggedIn ? <ResetPassword /> : <Navigate to="/auth/home" />,
  },
  {
    path: "terms-and-conditions",
    element: !isLoggedIn ? (
      <TermsAndConditions />
    ) : (
      <Navigate to="/auth/home" />
    ),
  },
  {
    path: "privacy-policy",
    element: !isLoggedIn ? <PrivacyPolicy /> : <Navigate to="/auth/home" />,
  },
  {
    path: "payment/status",
    element: isLoggedIn ? <PaymentStatus /> : <Navigate to="/login" />,
  },
  {
    path: "auth",
    element: isLoggedIn ? <Layout /> : <Navigate to="/" />,
    children: [
      { path: "home", element: <Home /> },
      { path: "home/assoiciates", element: <EmployeeDashboard /> },
      { path: `home/daily-recommendation`, element: <DailyRecomProfilePage /> },
      { path: `home/horoscopic`, element: <HoroscopeProfilePage /> },
      { path: `home/new-profiles`, element: <NewProfilesPage /> },
      { path: `home/preference`, element: <PreferenceProfiePage /> },
      { path: "home/view-profile/:id", element: <ViewProfile /> },
      { path: "wishList", element: <WishList /> },
      { path: `wishList/view-profile/:id`, element: <ViewProfile /> },
      { path: "profile", element: <Profile /> },
      { path: "edit-profile", element: <EditProfile /> },
      { path: "employee/edit-customer-profile", element: <CustomerId /> },
      { path: "edit-preference", element: <EditPreferences /> },
      { path: "profile-viewed", element: <ViewedProfile /> },
      { path: "search-by-partner", element: <SearchByPartner /> },
      {
        path: "search-by-partner/filtered-matches",
        element: <FilteredCustomers />,
      },
      { path: `profile-viewed/view-profile/:id`, element: <ViewProfile /> },
      { path: "profile-assist", element: <ProfileAssist /> },
      { path: "compare-profile", element: <CompareProfile /> },
      { path: "chat", element: <Chat /> },
      { path: "subscribe", element: <SubscriptionNew /> },
      { path: "history", element: <PaymentHistory /> },
      { path: "employees", element: <SubOrdinates /> },
      { path: "admin/dashboard", element: <AdminDashboard /> },

      { path: "associates", element: <Associates /> },
      { path: "associates/view-profile", element: <AssosiateProfile /> },
      { path: "associates/edit-profile", element: <EditAssosiateProfile /> },
      { path: "associates/earnings", element: <AssociateEarningsInfo /> },

      { path: "employees", element: <SubOrdinates /> },
      { path: "employee/home", element: <EmployeeDashboard /> },
      {
        path: "employee/view-profile",
        element: <SubOrdinatesViewProfile />,
      },
      {
        path: "employee/edit-profile",
        element: <EditSubordinateProfile />,
      },
      { path: "employee/earnings", element: <SubordinateEarningsInfo /> },
      { path: "employee/customer-details", element: <CustomerDetails /> },

      { path: "admin/create-assosiate", element: <CreateAssosiate /> },
      { path: "admin/create-subordinate", element: <CreateSubordinate /> },
      { path: "viewed-profile/:id", element: <ViewProfile /> },
    ],
  },
  {
    path: "*",
    element: <PageNotFound />,
  },
  {
    path: "/child-safety-standards",
    element: <ChildSafetyStandards />,
  },
  {
    path: "/about-us",
    element: <AboutUs />,
  },
  {
    path: "/services",
    element: <Services />,
  },
  {
    path: "/refund-policies",
    element: <RefundPolicies />,
  },
];

export default routes;
